export const siteName = "爆料直播";
export const siteTagline = "直播争议举报与处理公示平台";
export const siteEmail = "feedback@baoliaolive.example";
export const siteVision = "让每一次直播争议，都有据可查、有果可循。";
export const siteIntro =
  "爆料直播是一个专注直播争议举报与处理公示的公开平台。我们为观众提供画面中断快速反馈、主播违规投诉、直播争议事件全程跟踪与平台处理结果同步服务，让举报不再石沉大海，让处理过程经得起回看。";

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "举报通道", path: "/report" },
  { label: "争议事件", path: "/events" },
  { label: "处理结果", path: "/results" },
  { label: "关于我们", path: "/about" },
];

export const reportScopes = [
  {
    icon: "ri-live-line",
    title: "画面中断反馈",
    desc: "直播黑屏、卡顿、无声、画面回滚、长时间无法恢复，均可快速提交反馈，附带发生时间与房间信息。",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "主播违规投诉",
    desc: "涵盖违规营销、诱导私下交易、言语失范、内容越界等情形，投诉直达平台核查通道。",
  },
  {
    icon: "ri-refund-2-line",
    title: "消费与打赏争议",
    desc: "打赏未收到承诺内容、抽奖规则与实际不符、付费内容未履约等消费类争议，可提交证据材料。",
  },
  {
    icon: "ri-copyright-line",
    title: "版权与素材争议",
    desc: "翻唱、转播、素材挪用等版权相关争议，支持权利人提交权属说明与侵权比对信息。",
  },
];

export const reportSteps = [
  {
    step: "01",
    title: "填写举报线索",
    desc: "选择举报类型，填写直播平台、房间名与发生时间，尽可能描述清楚争议经过。",
  },
  {
    step: "02",
    title: "补充证据材料",
    desc: "提供截图、录屏链接、对话记录等可核验材料，材料越完整，核查越快。",
  },
  {
    step: "03",
    title: "平台受理与核查",
    desc: "提交后生成受理编号，平台在 24 小时内完成初步受理，进入核查流程。",
  },
  {
    step: "04",
    title: "结果同步与公示",
    desc: "核查结束后，处理结果第一时间同步给举报人，并在处理结果公示区对外展示。",
  },
];

export const timeCommitments = [
  { label: "初步受理", value: "24 小时内", note: "确认线索完整性并生成受理编号" },
  { label: "核查周期", value: "3–5 个工作日", note: "需要证明材料补充时同步延长并告知" },
  { label: "结果同步", value: "核查结束后 24 小时内", note: "站内信与邮箱双通道通知举报人" },
  { label: "公示时效", value: "同步公开", note: "处理结果进入公示区，接受回看与复盘" },
];

export const platformPrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "事实优先",
    desc: "以可核验的时间、房间、材料为依据，不凭片段情绪下结论，不预设任何一方立场。",
  },
  {
    icon: "ri-lock-2-line",
    title: "隐私保护",
    desc: "举报人信息严格保密，未获授权不向被举报方披露，公示内容隐去个人敏感信息。",
  },
  {
    icon: "ri-eye-line",
    title: "过程透明",
    desc: "每一个争议事件都公开时间线与处理进度，让举报人随时知道自己的线索走到哪一步。",
  },
  {
    icon: "ri-scales-3-line",
    title: "双向申诉",
    desc: "被举报方可在公示期内提交说明与反证，平台据实复核，避免单方面定性。",
  },
];

export const testimonials = [
  {
    name: "林一诺",
    role: "直播观众",
    content:
      "之前遇到直播间突然断流，商家和主播都没有解释。在爆料直播提交画面中断反馈后，第三天就收到了核查结果，处理过程能看到时间线，心里踏实多了。",
  },
  {
    name: "周叙白",
    role: "游戏主播",
    content:
      "被误举报的时候最怕没人听解释。这个平台给了双向申诉的入口，我提交了后台推流日志，最后核查结论写得很清楚，没有一棒子打死。",
  },
  {
    name: "沈素心",
    role: "消费维权用户",
    content:
      "打赏抽奖跟公示规则不一致，我抱着试试的心态投诉。材料上传之后有受理编号，进度可以查，最后平台的处理结果也公开了，这个透明度很难得。",
  },
  {
    name: "陈默",
    role: "行业观察者",
    content:
      "公示区能按处置类型和月份筛选，翻查过去几个月的处理记录很方便。对研究直播行业治理的人来说，这类结构化的公开数据很有参考价值。",
  },
];

export const reportNotes = [
  {
    title: "一次一条线索",
    desc: "一封信只描述一起争议事件，便于独立建档、独立跟踪，不同事件请分开提交。",
  },
  {
    title: "材料真实可核验",
    desc: "截图、录屏或对话记录应能回溯到具体时间点，平台将据此比对公开回放。",
  },
  {
    title: "涉及隐私请打码",
    desc: "请勿提交他人身份证件、住址等敏感材料；公示时平台也会隐去个人敏感信息。",
  },
  {
    title: "客观描述经过",
    desc: "尽量按时间顺序陈述事实，避免情绪化定性，核查结论由平台依据材料作出。",
  },
  {
    title: "恶意举报将被限制",
    desc: "重复提交明显不实的线索，会影响后续提交权限，请珍惜每一次举报机会。",
  },
  {
    title: "复核窗口七个工作日",
    desc: "对处理结果有异议，可在结果同步后 7 个工作日内提交复核申请并补充材料。",
  },
];

export const aboutStats = [
  { label: "累计受理举报", value: "42,860", note: "条" },
  { label: "争议事件建档", value: "3,174", note: "起" },
  { label: "平均受理时长", value: "17", note: "小时" },
  { label: "处理结果公示率", value: "96.4", note: "%" },
];